import './preregister.css';
import Spline from '@splinetool/react-spline';
import { useState } from 'react';
export default function PreRegister() {
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(null);
    const addSubscriber = async () => {
        console.log("hello")
        const response = await fetch('https://connect.mailerlite.com/api/subscribers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application / json',
                'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0IiwianRpIjoiMmQ4ZGQ4MWY0NGQyNGVhMjk4YzBkYWU1YjhjZWZkZDI1ZjIzMzVhM2VmZmVjNDNmNzY1OTg5MDBjOGY3MTc2MDVkZGFkMTdlMzYzMjliN2QiLCJpYXQiOjE3NTMyMTU2NjkuODM4Mzk4LCJuYmYiOjE3NTMyMTU2NjkuODM4NDAxLCJleHAiOjQ5MDg4ODkyNjkuODM0MzgxLCJzdWIiOiIxNjk3OTg0Iiwic2NvcGVzIjpbXX0.VSAMnJ4otUsUgRMSxnW9lQV0YWhkJOwSoxRp5tWj5nFOVZosvuDIPNN27RUy9Eu9trp7pCLmx_VhHBeQBBsZqzBAICXgHTV6pKGeshAwdkXa7Du-XS_o7cD_kZPLBSZx4eWZAR4JWhnGTScvNKCrgisFzdWe96TY4W9-mTnzhuTSIhln0NryvuKShyrlOB_7vPMZQd18S4ZQFz4DawlB_MOHC3Z_cOX9trPD8FkNP5RhYKVdPxYkysM0ekdwT6nNEkIDarIO9NhLvTKYW3muF0Z2K3RodfwSLeBejujFAPmVUM4TuJ5iib2uKnYIvrYm_c91JJnh3PqdbO3AcSHwKyJBa_bX5HuB1ekhGVDKkn7DpnLwa85moQvqVsGCCECTmPEoF0xxNAY4Lni_Hw8uViZOUEse3CxnGhbjMC3KvrD_8SkakkChP5_NVGhiFn6CNWM6AmsOoYGTt734BCpRumh-mq5_KUG5eK19QwfWaodCxCZdEhaRx7RsfE15zT0HEu_CafsMaacNDwTMB907sQGg7YClkX99OarXwa-SuzaNgXudr2r1qPsLEaFF3CFgNbTQnocabMozwJ-2kqyWlD1nWM_PLfVHMCJgJ8JHTvmW69olhmZ7zUEuPR4dVf6NL9zy_hV2jJgRqal9grS6E5AJ8VUsO3blu05HiYnWCFk',
            },
            body: JSON.stringify({
                email: email,
            }),
        });

        if (!response.ok) {
            const error = await response.json();
            console.error('Error:', error);
            setSuccess(false)
        } else {
            const data = await response.json();
            console.log('Success:', data);
            setEmail('')
            setSuccess(true)
        }
    };
    return (
        <div className="regContainer" id="preregister-section">
            <h2 className='Title hide'>Be the first to grow your forest 🌱</h2>
            <div className="splineWrapper">
                <Spline scene="https://prod.spline.design/mGRgzQkydhgzwm91/scene.splinecode" />
                <div className="overlayText">
                    {/* <img src={img} alt="orbis logo" /> */}
                </div>
            </div>
            <div className='form'>
                <h2 className='Title'>Be the first to grow your forest 🌱</h2>
                <input type="email" placeholder="Email Address"
                    value={email}
                    onChange={e => setEmail(e.target.value)} />

                <button onClick={addSubscriber} class="btn">Sign up</button>
                {success === true && <p style={{ color: "green" }}>Success! You are registered.</p>}
                {success === false && <p style={{ color: "red" }}>This email does not exist</p>}

            </div>
        </div>
    );
}
